/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Replace a condition's whole group/expression tree.
 * 
 * Replace rather than patch: groups and expressions have no external references, so
 * recreating them breaks nothing, and diffing a nested tree client-side is where the bugs
 * would be.
 * 
 * ``expected_version`` is the optimistic-concurrency token, echoed back from the ``version``
 * the read endpoint handed out. Opaque and compared as a string — see ``condition_version``
 * for why it must not be a datetime.
 * 
 * ``acknowledge_warnings`` covers a tree that cannot fire — an empty group matches
 * everything, a condition with no root groups never matches. Those are saveable, but only
 * once the client has been told and says so explicitly.
 * @export
 * @interface ConditionTreeWriteRequest
 */
export interface ConditionTreeWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof ConditionTreeWriteRequest
     */
    expectedVersion?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionTreeWriteRequest
     */
    acknowledgeWarnings?: boolean;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ConditionTreeWriteRequest
     */
    groups: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the ConditionTreeWriteRequest interface.
 */
export function instanceOfConditionTreeWriteRequest(value: object): value is ConditionTreeWriteRequest {
    if (!('groups' in value) || value['groups'] === undefined) return false;
    return true;
}

export function ConditionTreeWriteRequestFromJSON(json: any): ConditionTreeWriteRequest {
    return ConditionTreeWriteRequestFromJSONTyped(json, false);
}

export function ConditionTreeWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionTreeWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expectedVersion': json['expected_version'] === undefined ? undefined : json['expected_version'] === null ? null : json['expected_version'],
        'acknowledgeWarnings': json['acknowledge_warnings'] == null ? undefined : json['acknowledge_warnings'],
        'groups': json['groups'],
    };
}

export function ConditionTreeWriteRequestToJSON(json: any): ConditionTreeWriteRequest {
    return ConditionTreeWriteRequestToJSONTyped(json, false);
}

export function ConditionTreeWriteRequestToJSONTyped(value?: ConditionTreeWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_version': value['expectedVersion'],
        'acknowledge_warnings': value['acknowledgeWarnings'],
        'groups': value['groups'],
    };
}

